import { render, staticRenderFns } from "./setting-display-companies.vue?vue&type=template&id=5d32c0a2&scoped=true"
import script from "./setting-display-companies.vue?vue&type=script&lang=js"
export * from "./setting-display-companies.vue?vue&type=script&lang=js"
import style0 from "./setting-display-companies.vue?vue&type=style&index=0&id=5d32c0a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32c0a2",
  null
  
)

export default component.exports